var _rect, _rect2, _rect3, _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearchResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 185,
    viewBox: "0 0 149 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.0264,
    y: 34.1753,
    width: 24.3265,
    height: 4.86531,
    rx: 2.43265,
    transform: "rotate(-135.162 32.0264 34.1753)",
    fill: "#F0F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80469,
    y: 37.1826,
    width: 18.2449,
    height: 4.86531,
    rx: 2.43265,
    transform: "rotate(-4.72994 9.80469 37.1826)",
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7158,
    y: 8.9624,
    width: 18.2449,
    height: 4.86531,
    rx: 2.43265,
    transform: "rotate(86.5404 40.7158 8.9624)",
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.627 75.9063V36.4897H44.6619C40.8072 36.4897 37.7061 39.5909 37.7061 43.4456V177.926C37.7061 181.78 40.8072 184.882 44.6619 184.882H142.044C145.899 184.882 149 181.78 149 177.926V82.8622H109.583C105.758 82.8622 102.627 79.7321 102.627 75.9063ZM149 71.8198V73.5877H111.902V36.4897H113.67C115.525 36.4897 117.293 37.2143 118.597 38.5185L146.971 66.9217C148.275 68.2259 149 69.9938 149 71.8198Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.339 67.5534L146.339 67.5538C147.475 68.6894 148.106 70.2296 148.106 71.8198V72.6938H112.796V37.3837H113.67C115.291 37.3837 116.831 38.0164 117.965 39.1506L146.339 67.5534ZM101.734 37.3837V75.9063C101.734 80.2258 105.264 83.7561 109.583 83.7561H148.106V177.926C148.106 181.287 145.405 183.988 142.044 183.988H44.6619C41.3009 183.988 38.6 181.287 38.6 177.926V43.4456C38.6 40.0846 41.3009 37.3837 44.6619 37.3837H101.734Z",
    stroke: "white",
    strokeOpacity: 0.02,
    strokeWidth: 1.78785
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.3723,
    cy: 118.361,
    r: 6.45827,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.333,
    cy: 118.361,
    r: 6.45827,
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.797 140.652C111.882 133.737 102.502 129.852 92.7227 129.852C82.9429 129.852 74.828 132.472 67.9127 139.388",
    stroke: "#C4C4C4",
    strokeWidth: 1.78785
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchResult);
export default __webpack_public_path__ + "static/media/empty-search-result.3f7e602a197c7ab132e61b8755e079a3.svg";
export { ForwardRef as ReactComponent };